import React from 'react';
import PropTypes from 'prop-types';
import {DragSource} from 'react-dnd';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import './JSONTable.scss';
import {Button} from 'react-bootstrap';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import {JSON_TABLE_LAST} from './JSONTableConfigTable.react';

const messages = defineMessages({
	addButtonTitle: {id: 'jsonDragColumn.button.addTitle', 'defaultMessage': 'Add to the grid'},
});

export const JSONTableColumnDragType = 'JSONTableDragColumn';

class DragColumn extends React.Component {
	static propTypes = {
		column: PropTypes.object.isRequired,
		connectDragPreview: PropTypes.func.isRequired,
		connectDragSource: PropTypes.func.isRequired,
		dragEndFn: PropTypes.func,
		dropFn: PropTypes.func,
		intl: PropTypes.object.isRequired,
		isDragging: PropTypes.bool.isRequired,
		searchValue: PropTypes.string,
	};

	constructor(props) {
		super(props);

		this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
	}

	add() {
		this.props.dropFn({column: this.props.column}, JSON_TABLE_LAST);
	}

	higlightInText(text) {
		if (-1 === text.toLowerCase().indexOf(this.props.searchValue)) {
			return text;
		}

		let highligthStart = text.toLowerCase().indexOf(this.props.searchValue);
		let highlightLength = this.props.searchValue.length;

		let start = text.substring(0, highligthStart);
		let middle = text.substring(highligthStart, highligthStart + highlightLength); //cannot be searchValue as it might have different cappitalization
		let end = text.substring(highligthStart + highlightLength);

		return [start, <span className="highlight" key={text} >{middle}</span>, this.higlightInText(end)];
	}

	getDisplayedName() {
		if (this.props.searchValue) {
			return (<span className="columnLabel">{this.higlightInText(this.props.column.name)}</span>);
		}

		return (<span className="columnLabel">{this.props.column.name}</span>);
	}

	render() {
		return (
			this.props.connectDragSource(
				<div className={"columnToDrag" + (this.props.isDragging ? " dragging" : '')} key={this.props.column.realId}>
					{this.getDisplayedName()}

					<span className="flex" />

					<Button bsStyle="success" onClick={this.add.bind(this)} title={this.props.intl.formatMessage(messages.addButtonTitle)}>
						<span className="fa fa-plus"></span>
					</Button>
				</div>
			)
		);
	}
}

const columnHandler = {
	beginDrag(props) {
		return {
			column: props.column,
		};
	},

	endDrag(props, monitor) {
		if (!monitor.didDrop()) {
			props.dragEndFn();
		}
	},
};

function collectActions(connect, monitor) {
	return {
		connectDragPreview: connect.dragPreview(),
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging()
	};
}

export default DragSource('JSONTableDragColumn', columnHandler, collectActions)(injectIntl(DragColumn));
